import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const NoRowsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
  width: '100%',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  fontSize: '0.95rem',
  marginLeft: '-30px',
  fontWeight: 500,
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[50],
}))

export const NoRowsOverlay = () => (
  <NoRowsWrapper>
    <StyledTypography variant="body2">No results found</StyledTypography>
  </NoRowsWrapper>
)
